/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updateyourbusinessinformationandsettings5Inputs */

const en_updateyourbusinessinformationandsettings5 = /** @type {(inputs: Updateyourbusinessinformationandsettings5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your business information and settings`)
};

const de_updateyourbusinessinformationandsettings5 = /** @type {(inputs: Updateyourbusinessinformationandsettings5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändere die Infos und Einstellungen deines Unternehmens.`)
};

/**
* | output |
* | --- |
* | "Update your business information and settings" |
*
* @param {Updateyourbusinessinformationandsettings5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const updateyourbusinessinformationandsettings5 = /** @type {((inputs?: Updateyourbusinessinformationandsettings5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updateyourbusinessinformationandsettings5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updateyourbusinessinformationandsettings5(inputs)
	return de_updateyourbusinessinformationandsettings5(inputs)
});
export { updateyourbusinessinformationandsettings5 as "updateYourBusinessInformationAndSettings" }